import {
	ApiClientManager,
	GenerateQrCodeInputDto,
	GenerateQrCodeOutputDtoSingleOutputMessage,
} from '@api/consumerloans-public-api';
import { UseFetchHookOutput } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$hooks';
import { useFetch } from '@hooks';
import { useLoadingStore, usePTCMetadata, useServicesStore, useTempStore } from '@store';

export const useFetchGetQRCodeAndLink = (): UseFetchHookOutput<
	GenerateQrCodeInputDto,
	GenerateQrCodeOutputDtoSingleOutputMessage
> => {
	const metadata = usePTCMetadata();
	const { inputData, creditTypeSelected } = useTempStore();
	const { term, amount } = inputData;
	const { creditType } = creditTypeSelected;
	const applicationContextId = useServicesStore((state) => state.init?.applicationContextId);
	const saveServiceResponse = useServicesStore((state) => state.saveServiceResponse);
	const { setIsLoadingQRCodeAndLink } = useLoadingStore();

	return useFetch({
		fetchFn: () =>
			ApiClientManager.call.generateQRCode({
				data: {
					metadata,
					amount,
					term,
					creditType,
					applicationContextId,
				},
			}),
		onSuccess: (res: GenerateQrCodeOutputDtoSingleOutputMessage) => {
			if (res.data) {
				saveServiceResponse({
					qrCodeToApp: res.data.imageBase64 || '',
					linkToApp: res.data.linkSimulator,
				});
				setIsLoadingQRCodeAndLink(false);
			}
		},
		onError: () => {
			setIsLoadingQRCodeAndLink(false);
		},
	});
};
